import type { Metric } from '@/api/dashboard'

interface Props {
  metric: Metric
  featured?: boolean
}

function formatValue(value: number): string {
  return value.toLocaleString('ru-RU')
}

function formatDelta(delta: number, unit?: string): string {
  if (delta === 0) return '0'
  const abs = Math.abs(delta)
  const formatted = abs.toLocaleString('ru-RU')
  const sign = delta > 0 ? '+' : '−'
  if (unit) return `${sign}${formatted} ${unit}`
  return `${sign}${formatted}`
}

export function MetricCard({ metric, featured }: Props) {
  const hasValue = metric.value !== null
  const deltaMonth = metric.deltas.month
  const hasDelta = deltaMonth !== null && deltaMonth !== 0
  const deltaCls = !hasDelta ? 'zero' : deltaMonth > 0 ? 'up' : 'dn'

  return (
    <div className={`kpi ${featured ? 'featured' : ''} ${!hasValue ? 'empty' : ''}`}>
      <div className="kpi-label">
        {metric.label}
        <svg className="kpi-label-help" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="9" />
          <path d="M9 9c0-2 1.5-3 3-3s3 1 3 3-3 2-3 4M12 17v.01" />
        </svg>
      </div>

      <div className="kpi-value">
        {hasValue ? formatValue(metric.value!) : '—'}
        {hasValue && metric.unit && <span className="kpi-value-unit">{metric.unit}</span>}
      </div>

      {hasValue && (
        <>
          <div className={`kpi-delta ${deltaCls}`}>
            {hasDelta && (
              <svg className="kpi-delta-arrow" viewBox="0 0 12 12" fill="currentColor">
                {deltaMonth! > 0 ? (
                  <path d="M6 2L11 9H7v3H5V9H1z" />
                ) : (
                  <path d="M6 10L1 3h4V0h2v3h4z" />
                )}
              </svg>
            )}
            <span>
              {deltaMonth !== null ? (
                <>
                  {formatDelta(deltaMonth, metric.unit)} <span className="kpi-delta-period">за месяц</span>
                </>
              ) : (
                <span className="kpi-delta-period">— нет данных</span>
              )}
            </span>
          </div>
          <div className="kpi-mini-deltas">
            <span>День: {metric.deltas.day !== null ? formatDelta(metric.deltas.day, metric.unit) : '—'}</span>
            <span>·</span>
            <span>Неделя: {metric.deltas.week !== null ? formatDelta(metric.deltas.week, metric.unit) : '—'}</span>
          </div>
        </>
      )}

      {!hasValue && (
        <div className="kpi-empty-hint">Скоро будет доступно</div>
      )}
    </div>
  )
}
